import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { EventApi } from 'api';
import { SearchEventQueryType } from 'types';

function useGetAll(query: SearchEventQueryType) {
  return useAuthQuery(
    getQueryKeys([KEY]).list({ ...query }),
    () => EventApi.getAll(query),
    {
      select: (data) => data.data,
    },
  );
}

export default useGetAll;
